export enum OrderStatus {
    Pending = 'pending',
    processing = 'processing',
    OnHold = 'on-hold',
    Completed = 'completed',
    Cancelled = 'cancelled',
    Refunded = 'refunded',
    Failed = 'failed',
    CheckoutDraft = 'checkout-draft',
    Livrare = 'livrare',
    MesajPrivat = 'mesajprivat',
    Ratellp = 'ratellp',
    Livratclient = 'livratclient',
    Plataramburs = 'plataramburs',
    Ridicatclient = 'ridicatclient'
}
